const i = () => {
  const o = {};
  return { on: (t, e) => {
    var r;
    return o[t] || (o[t] = /* @__PURE__ */ new Set()), (r = o[t]) == null || r.add(e), () => {
      var n;
      return (n = o[t]) == null ? void 0 : n.delete(e);
    };
  }, emit: (t, e) => {
    var r, n;
    (r = o[t]) == null || r.forEach((c) => c(e)), (n = o["*"]) == null || n.forEach((c) => c({ type: t, payload: e }));
  } };
};
export {
  i as createEventEmitter
};
